import { useState } from "react";
import { useDispatch } from "react-redux";
import { disconnectGmail } from "../reducers/personalReducer/personalReducer";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";

const DisconnectGmailModal = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="tw-bg-transparent tw-border-none tw-p-0 tw-text-12d tw-font-semibold hover:tw-underline tw-text-semantic-red-100"
      >
        Disconnect
      </button>

      <Modal
        containerClassName="!tw-z-3000"
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        {/* @ts-expect-error props */}
        <Modal.Header title="Disconnect?" closeButton />
        {/* @ts-expect-error props */}
        <Modal.Body>Are you sure you want to disconnect your email account?</Modal.Body>
        <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
          {/* @ts-expect-error props */}
          <Button schema="tertiary" size="medium" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          {/* @ts-expect-error props */}
          <Button
            data-cy="disconnect"
            schema="warning"
            size="medium"
            onClick={() => {
              // @ts-expect-error dispatch
              dispatch(disconnectGmail());
              setShowModal(false);
            }}
          >
            Disconnect
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DisconnectGmailModal;
